module.exports = __webpack_public_path__ + "img/cityRestHilai.d130a18a.jpg";